export const parse = rawData => ({
    kwfinder: rawData.kwfinder,
    kwfinderBeta: rawData.kwfinder_beta,
});
